let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fC8IH")).then(() => parcelRequire('ba3HB'));